module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_8019.8049247b.png";